import { useEffect } from 'react'

import { Center, Spinner } from '@chakra-ui/react'
import { Paths } from 'src/constants/paths'

import { buildAuth0LogoutUrl } from '../../utils/buildAuth0LogoutUrl'

/**
 * Cognitoのログアウト後に経由する中継画面。Auth0の`/v2/logout`へ遷移してAuth0のセッションも破棄する。
 *
 * 通常はSPAを起動する前に`redirectFromLogoutComplete()`がリダイレクトするため、この画面は
 * 描画されない。パスが完全一致しない場合（末尾スラッシュ付きなど）のフォールバックとして残している。
 *
 * この画面に到達した時点でCognitoからはサインアウト済みのため、認証必須にしてはいけない
 * （`withAuthenticator()`で包むとAuth0へ遷移する前に`/login`へ弾かれ、チェーンが途切れる）。
 * 同じ理由でこの画面から`signOut()`を呼んでもいけない（Cognitoがこの画面に戻してループする）。
 */
export const LogoutCompleteScreen = () => {
  useEffect(() => {
    window.location.replace(buildAuth0LogoutUrl() ?? Paths.Login)
  }, [])

  return (
    <Center h="100vh" w="full">
      <Spinner />
    </Center>
  )
}
